// Copyright (c) 2016 Deere & Company

import Claim, {getDefaultState as getClaimDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-jd-promise';
import {
    findMatchingAccount,
    findMatchingKey
} from '../../../shared/services/claim-shared-helper';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import actions from '../action-list';
import {getDefaultState} from '../state';

const copyClaim = state => {

    const defaultClaim = getClaimDefaultState();

    return Claim.update(state, {
        $merge: {
            allowedActions: [
                new ClaimAction({
                    actionName: 'DRAFT',
                    id: 'DRAFT',
                    mode: 'CHG'
                }),
                new ClaimAction({
                    actionName: 'SAVE_VALD',
                    id: 'SAVE_VALD',
                    mode: 'CHG'
                })
            ],
            claimNumber: defaultClaim.claimNumber,
            claimStatus: defaultClaim.claimStatus,
            claimValueDetails: defaultClaim.claimValueDetails,
            errors: defaultClaim.errors,
            recordInfo: defaultClaim.recordInfo,
            reimbursementDetails: defaultClaim.reimbursementDetails
        }
    });

};

const updateRepairNumber = (state, action) =>
    Claim.update(state, {
        referenceInfo: {
            repairNumber: {
                $set: action.repairNumber
            }
        }
    });

const updateWorkOrderOne = (state, action) =>
    Claim.update(state, {
        referenceInfo: {
            referenceNumber1: {
                $set: action.workOrder
            }
        }
    });

const updateClaimProperty = (state, action) =>
    Claim.update(state, {
        [action.property]: {
            $set: action.value
        }
    });

const updateResponsibleAccounts = (state, action) =>
    Claim.update(state, {
        responsibleAccount: {
            $set: findMatchingAccount(action.accountId, action.dealerCollection)
        }
    });

const updateType = (state, action) =>
    Claim.update(state, {
        $merge: {
            model: '',
            serialNumber: '',
            specialAllowanceType: findMatchingKey(action.jdpType, action.collection)
        }
    });

const resetJdpClaim = () => getClaimDefaultState();

const addFile = (state, action) =>
    Claim.update(state, {
        file: {
            $push: [action.data]
        }
    });

const deleteFile = (state, action) => {

    const index = state.file.findIndex(file => file.serialNumber === action.data.serialNumber && file.name === action.data.name);

    return Claim.update(state, {
        file: {
            $splice: [[index, 1]]
        }
    });

};

const updateFile = (state, action) =>
    Claim.update(state, {
        file: {
            $set: action.files
        }
    });

const updateCustomerResolution = (state, action) =>
    Claim.update(state, {
        jdpCustomerResolution: {
            $set: findMatchingKey(action.key, action.statusCollection)
        }
    });

const updateReasonForReturn = (state, action) =>
    Claim.update(state, {
        jdpReason: {
            $set: findMatchingKey(action.key, action.statusCollection)
        }
    });

const setJdpClaim = (state, action) =>
    Claim.update(state, {
        $set: action.updatedClaim
    });

const updateGoodsInstallationVat = (state, action) =>
    Claim.update(state, {
        goodsInstallationVat: {
            $set: action.goodsInstallationVat
        }
    });

const reviseJdpClaim = state =>
    Claim.update(state, {
        errors: {
            $set: []
        }
    });

export default (state = getDefaultState().claim, action) => {

    const actionTypes = {
        [actions.ADD_CLAIM_JDP_FILE]: addFile,
        [actions.DELETE_CLAIM_JDP_FILE]: deleteFile,
        [actions.COPY_CLAIM_JDP]: copyClaim,
        [actions.RESET_CLAIM_JDP]: resetJdpClaim,
        [actions.REVISE_CLAIM_JDP]: reviseJdpClaim,
        [actions.SET_CLAIM_JDP]: setJdpClaim,
        [actions.UPDATE_CLAIM_JDP_DELIVERY_DATE]: updateClaimProperty,
        [actions.UPDATE_CLAIM_JDP_PROPERTY]: updateClaimProperty,
        [actions.UPDATE_CLAIM_JDP_CUSTOMER_RESOLUTION]: updateCustomerResolution,
        [actions.UPDATE_CLAIM_JDP_REASON_FOR_RETURN]: updateReasonForReturn,
        [actions.UPDATE_CLAIM_JDP_RETURN_DATE]: updateClaimProperty,
        [actions.UPDATE_CLAIM_JDP_REPAIR_NUMBER]: updateRepairNumber,
        [actions.UPDATE_CLAIM_JDP_RESPONSIBLE_ACCOUNTS]: updateResponsibleAccounts,
        [actions.UPDATE_CLAIM_JDP_TYPE]: updateType,
        [actions.UPDATE_CLAIM_JDP_WORK_ORDER_ONE]: updateWorkOrderOne,
        [actions.UPDATE_CLAIM_JDP_GOODS_INSTALLATION_VAT]: updateGoodsInstallationVat,
        [actions.UPDATE_CLAIM_JDP_FILE_LIST]: updateFile
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/reducers/jdp-claim.js